import { render, staticRenderFns } from "./DlqiParameter.vue?vue&type=template&id=09c8ed4c&scoped=true&"
import script from "./DlqiParameter.vue?vue&type=script&lang=js&"
export * from "./DlqiParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c8ed4c",
  null
  
)

export default component.exports